import * as React from "react";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { FirmType } from "../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { CompanyDetail } from "../../../../../../Wrap/Models/Models/Company/CompanyDetail";
import { Table } from "../../../../../Shared/Table/Table";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { BackOffice } from "../CompanySetUpWizard/Commission/BackOffice";
import { Methods } from "../../../../../Dashboard/Common/CommonHelper";
import { DisinvestmentStrategyTypeMap } from "../../../../../Dashboard/Components/Clients/PortfolioDashboard/Components/ProductOverview/Constant/Content";
import { DisinvestmentStrategyTypeStringMap } from "../../../../../Dashboard/Components/Clients/NewBusinessWizard/Resource/Contents";
import { ServiceProposition } from "../../../../../../Wrap/Constants/Enums/ServiceProposition";

interface ICommissionProps extends React.Props<Commission> {
    data: CompanyDetail;
}

interface ICommissionState {}

export class Commission extends BaseComponent<ICommissionProps, ICommissionState> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const { data } = this.props;
        const createType =
            data.FirmType == FirmType.AppointedRepresentative || data.FirmType == FirmType.DirectlyAuthorised
                ? "adviser"
                : "thirdParty";

        return (
            <>
                <h2>Firm remuneration settings</h2>
                {data.AcornCommissionSettings && (
                    <Typography
                        type="common"
                        config={[
                            {
                                title: "Frequency",
                                data: Methods.getFormatFrequencyType(data.AcornCommissionSettings.Frequency),
                            },
                            {
                                title: "Next payment date",
                                data: JsonDateParser.getFormatDateString(
                                    JsonDateParser.toDate(data.AcornCommissionSettings.NextPayDate),
                                    "dd-MM-yyyy",
                                    true,
                                    true
                                ),
                            },
                            {
                                title: "Generate Online Statement",
                                data: data.AcornCommissionSettings.RequestStatement ? "Yes" : "No",
                            },
                            {
                                title: "Generate EDI File",
                                data: data.AcornCommissionSettings.RequestEDIFile ? "Yes" : "No",
                            },
                            {
                                title: "Suspend Charges Payment",
                                data: data.AcornCommissionSettings.SuspendCommissionPayments ? "Yes" : "No",
                            },
                        ]}
                    />
                )}
                <hr />
                {!data.ServicePropositions.every((ele) => ele == ServiceProposition.Fundzone) && (
                    <>
                        <h2>Disinvestment strategy</h2>
                        <Typography
                            type="common"
                            config={[
                                {
                                    title: "Firm Disinvestment Strategy",
                                    data:
                                        DisinvestmentStrategyTypeMap[
                                            DisinvestmentStrategyTypeStringMap(data.DisinvestmentStrategy)
                                        ] ?? "None", //this.getLabel(data.DisinvestmentStrategy),
                                },
                            ]}
                        />
                        <hr />
                    </>
                )}

                <BackOffice
                    data={this.props.data.BackOfficeProviderSettings}
                    onChange={() => {}}
                    onRef={(ref) => {}}
                    isReview={true}
                />
                <hr />
                <h2>Bank details</h2>
                <Table
                    data={data.BankAccountList}
                    col={[
                        { title: "Account reference", key: "AccountReference" },
                        { title: "Account name", key: "AccountName" },
                        { title: "Bank name", key: "BankName" },
                        { title: "Sort code", key: "SortCode" },
                        { title: "Account number", key: "AccountNumber" },
                        {
                            title: "Is default",
                            key: "IsDefault",
                            render: (ele, row, index) => {
                                return <span>{ele ? "Yes" : "No"}</span>;
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
